import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnInit, Type } from '@angular/core';

import { DeveloperToolsService } from '@services/developer-tools.service';
import { FullStoryService } from '@services/fullstory.service';

import { QuotingFlowStore } from './services/quoting-flow.store';
import { ClientLookupStep } from './steps/client-lookup/client-lookup.step';
import { ConfirmationModal } from './steps/confirmation.modal';
import { PropertyReviewStep } from './steps/property-review/property-review.step';
import { QuoteReviewStep } from './steps/quote-review/quote-review.step';
import { QUOTING_FLOW_STEPS, QuotingFlowStep, QuotingFlowStepTitle } from './types/quoting-flow.types';

const STEP_TO_COMPONENT_LOOKUP: Record<QuotingFlowStep, Type<unknown>> = {
  CLIENT_LOOKUP: ClientLookupStep,
  PROPERTY_REVIEW: PropertyReviewStep,
  QUOTE_REVIEW: QuoteReviewStep,
};

@Component({
  selector: 'hsc-quoting-flow',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [CommonModule, ConfirmationModal],
  providers: [QuotingFlowStore],
  templateUrl: './quoting-flow.html',
})
export class QuotingFlow implements OnInit {
  // Services
  readonly developerToolsService = inject(DeveloperToolsService);
  readonly qfStore = inject(QuotingFlowStore);
  private readonly fullStoryService = inject(FullStoryService);

  // Component Properties
  readonly qfSteps = QUOTING_FLOW_STEPS;

  ngOnInit(): void {
    // Define the top of the funnel to see how many users visit vs actually quote
    this.fullStoryService.event('Quote Flow Opened');
  }

  get currentStepTitle(): QuotingFlowStepTitle {
    return QUOTING_FLOW_STEPS[this.qfStore.step()].title;
  }

  get currentStepComponent(): Type<unknown> {
    return STEP_TO_COMPONENT_LOOKUP[this.qfStore.step()];
  }
}
